/**
 * 根据数据最小值生成折线图Y轴最小刻度
 * 数据最低值向下靠近referNum的整数倍数值，最小值不低于0
 * 适用范围：Y周刻度为自然数
 *
 * @param {object} value Y轴的实际数据，包括：max、min
 * @param {number} referNum 每个刻度是多少的整数倍
 * @return {number} Y轴最小刻度，默认值：0
 */
export const getYAxisNumMin = (value, referNum) => {
  const res = value.min

  if (res <= 0) return 0

  return (res - (res % referNum)) || 0
}

/**
 * 根据数据最大值生成折线图Y轴最大刻度
 * 数据最高值向上靠近“参考值”的整数倍数值
 * 适用范围：Y周刻度为自然数
 *
 * @param {object} value Y轴的实际数据，包括：max、min
 * @param {number} referNum 每个刻度是多少的整数倍
 * @return {number} Y轴最大刻度，默认值：5
 */
export const getYAxisNumMax = (value, referNum) => {
  const res = value.max

  if (res <= 0) return 5

  return (res % referNum > 0 ? (Math.floor(res / referNum) + 1) * referNum : res) || 5
}

/**
 * 根据数据最小值生成折线图Y轴最小刻度
 * 数据最低值-referNum%，再向下取整referNum位数的百分比，最小值不低于0%
 * 举例：数据最低值-10%，再向下取整10位数的百分比，最小值不低于0%
 * 适用范围：Y周刻度为百分比
 *
 * @param {object} value Y轴的实际数据，包括：max、min
 * @param {number} referNum 每个刻度是多少的整数倍
 * @return {number} Y轴最小刻度，默认值：0
 */
export const getYAxisPercentMin = (value, referNum) => {
  const res = value.min - referNum

  if (res <= 0) return 0

  return (res - (res % referNum)) || 0
}

/**
 * 根据数据最大值生成折线图Y轴最大刻度
 * 数据最高值向上靠近“参考值”的整数倍数值
 * 适用范围：Y周刻度为百分比
 *
 * @param {object} value Y轴的实际数据，包括：max、min
 * @param {number} referNum 每个刻度是多少的整数倍
 * @return {number} Y轴最大刻度，默认值：100
 */
export const getYAxisPercentMax = (value, referNum) => {
  const res = value.max

  if (res <= 100) return 100

  return (res % referNum > 0 ? (Math.floor(res / referNum) + 1) * referNum : res) || 100
}
